export default __webpack_public_path__ + "ba32476228b633bcc72c211f3dfed7fc.png";